import {
	faCalendar,
	faLocationArrow,
	faLocationCrosshairs,
	faLock,
	faMapLocation,
	faPhone,
	faUser,
	faVenusMars,
} from "@fortawesome/free-solid-svg-icons";
import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { connect, useDispatch } from "react-redux";
import fullLogo from "../../images/full_logo.svg";
import formImage from "../../images/image.png";
import registerSuccess from "../../images/svgs/register-success.svg";
import { sendOTP, verifyOTP } from "../../store/thunks/register";
import { showToast } from "../../store/thunks/toasts";
import { registerVolunteer } from "../../store/thunks/volunteerRegistrations";
import {
	GENDER,
	MEDICAL_CONDITIONS,
	REGION,
	RESEND_OTP_TIMEOUT_IN_SECONDS,
	STATE_DANGER,
	STATE_DEFAULT,
	STATES,
	TOAST_STATE_DANGER,
	VOLUNTEER_AREAS,
	VOLUNTEER_MAX_AGE_IN_YEARS,
	VOLUNTEER_MIN_AGE_IN_YEARS,
} from "../../utils/constants";
import Button from "../DesignSystem/Button/Button";
import Checkbox from "../DesignSystem/Checkbox/Checkbox";
import CustomInput from "../DesignSystem/CustomInput/CustomInput";
import Dropdown from "../DesignSystem/Dropdown/Dropdown";
import Header from "../Header/Header";
import "./VolunteerRegistration.scss";
import Webcam from "react-webcam";
import image from "../../images/image.svg";

let resendOTPTimer = null;

export default connect(
	(state) => ({
		...state.registrations,
	}),
	{ sendOTP, verifyOTP, registerVolunteer }
)(() => {
	const dispatch = useDispatch();
	const { formatMessage } = useIntl();

	const [firstName, setFirstName] = useState("");
	const [firstNameInputState, setFirstNameInputState] = useState("");
	const [firstNameError, setFirstNameError] = useState("");

	const [lastName, setLastName] = useState("");
	const [lastNameInputState, setLastNameInputState] = useState("");
	const [lastNameError, setLastNameError] = useState("");

	const [dob, setDob] = useState("");
	const [dobError, setDobError] = useState("");
	const [dobInputState, setDobInputState] = useState("");

	const [phoneNumber, setPhoneNumber] = useState("");
	const [phoneNumberError, setPhoneNumberError] = useState("");
	const [phoneNumberInputState, setPhoneNumberInputState] = useState("");

	const [otp, setOtp] = useState("");
	const [otpError, setOtpError] = useState("");
	const [otpInputState, setOtpInputState] = useState("");

	const [genderOptions, setGenderOptions] = useState("");
	const [gender, setGender] = useState("");
	const [genderError, setGenderError] = useState("");
	const [genderInputState, setGenderInputState] = useState("");

	const [medicalCondition, setMedicalCondition] = useState("");
	const [medicalConditionInputState, setMedicalConditionInputState] = useState("");
	const [medicalConditionError, setMedicalConditionError] = useState("");

	const [city, setCity] = useState("");
	const [cityInputState, setCityInputState] = useState("");
	const [cityError, setCityError] = useState("");

	const [state, setState] = useState("");
	const [stateInputState, setStateInputState] = useState("");
	const [stateError, setStateError] = useState("");

	const [address, setAddress] = useState("");
	const [addressInputState, setAddressInputState] = useState("");
	const [addressError, setAddressError] = useState("");

	const [pincode, setPincode] = useState("");
	const [pincodeInputState, setPincodeInputState] = useState("");
	const [pincodeError, setPincodeError] = useState("");

	const [region, setRegion] = useState("");
	const [regionInputState, setRegionInputState] = useState("");
	const [regionError, setRegionError] = useState("");

	const [volunteerArea, setVolunteerArea] = useState("");
	const [volunteerAreaInputState, setVolunteerAreaInputState] = useState("");
	const [volunteerAreaError, setVolunteerAreaError] = useState("");

	const [startDate, setStartDate] = useState("");
	const [startDateError, setStartDateError] = useState("");
	const [startDateInputState, setStartDateInputState] = useState("");

	const [endDate, setEndDate] = useState("");
	const [endDateError, setEndDateError] = useState("");
	const [endDateInputState, setEndDateInputState] = useState("");

	const [webcamImage, setWebcamImage] = useState(null);
	const [isPhotoCaptured, setIsPhotoCaptured] = useState(false);
	const [isTakingPicture, setIsTakingPicture] = useState(false);
	const [photoError, setPhotoError] = useState("");

	const [isAgreedToTerms, setIsAgreedToTerms] = useState(false);
	const [isAgreedToTermsInputState, setIsAgreedToTermsInputState] = useState("");
	const [isAgreedToTermsError, setIsAgreedToTermsError] = useState("");

	const [sendOtpButtonDisabledState, setSendOtpButtonDisabledState] = useState(true);
	const [verifyOTPButtonDisabledState, setVerifyOTPButtonDisabledState] = useState(true);
	const [hasMedicalCondition, setHasMedicalCondition] = useState(false);
	const [buttonDisabled, setButtonDisabled] = useState(true);
	const [resendOTPMessage, setResendOTPMessage] = useState(null);
	const [isRegistrationSuccessful, setIsRegistrationSuccessful] = useState(false);

	const [formStateMapping, setFromStateMapping] = useState({
		firstName: {
			isSet: false,
			setErrorFunc: setFirstNameError,
			setState: setFirstNameInputState,
		},
		lastName: {
			isSet: false,
			setErrorFunc: setLastNameError,
			setState: setLastNameInputState,
		},
		gender: {
			isSet: false,
			setErrorFunc: setGenderError,
			setState: setGenderInputState,
		},
		dob: {
			isSet: false,
			setErrorFunc: setDobError,
			setState: setDobInputState,
		},
		phoneNumber: {
			isSet: false,
			setErrorFunc: setPhoneNumberError,
			setState: setPhoneNumberInputState,
		},
		otp: {
			isSet: false,
			setErrorFunc: setOtpError,
			setState: setOtpInputState,
		},
		city: {
			isSet: false,
			setErrorFunc: setCityError,
			setState: setCityInputState,
		},
		state: {
			isSet: false,
			setErrorFunc: setStateError,
			setState: setStateInputState,
		},
		address: {
			isSet: false,
			setErrorFunc: setAddressError,
			setState: setAddressInputState,
		},
		pincode: {
			isSet: false,
			setErrorFunc: setPincodeError,
			setState: setPincodeInputState,
		},
		region: {
			isSet: false,
			setErrorFunc: setRegionError,
			setState: setRegionInputState,
		},
		volunteerArea: {
			isSet: false,
			setErrorFunc: setVolunteerAreaError,
			setState: setVolunteerAreaInputState,
		},
		startDate: {
			isSet: false,
			setErrorFunc: setStartDateError,
			setState: setStartDateInputState,
		},
		endDate: {
			isSet: false,
			setErrorFunc: setEndDateError,
			setState: setEndDateInputState,
		},
		photo: {
			isSet: false,
			setErrorFunc: setPhotoError,
		},
		medicalConditions: {
			isSet: false,
		},
		termsAndConditions: {
			isSet: false,
			setErrorFunc: setIsAgreedToTermsError,
			setState: setIsAgreedToTermsInputState,
		},
	});

	const firstNameInput = useRef();
	const lastNameInput = useRef();
	const dobInput = useRef();
	const phoneNumberInput = useRef();
	const otpInput = useRef();
	const genderInput = useRef();
	const medicalConditionInput = useRef();
	const cityInput = useRef();
	const stateInput = useRef();
	const addressInput = useRef();
	const pincodeInput = useRef();
	const regionInput = useRef();
	const volunteerAreaInput = useRef();
	const startDateInput = useRef();
	const endDateInput = useRef();
	const webcamRef = useRef(null);

	useEffect(() => {
		let genderOptions = [];

		GENDER.forEach((gen) => {
			genderOptions.push(formatMessage({ id: `volunteer.registration.${gen.label}` }));
		});

		setGenderOptions(genderOptions);
	}, [formatMessage]);

	const validateField = (inputValue, onError, errorMessage, stateKey) => {
		let isError = false;

		if (!inputValue.length) {
			onError(formatMessage({ id: errorMessage }));
			isError = true;
		}

		if (isError) {
			setButtonDisabled(true);
			formStateMapping[stateKey].isSet = false;
		} else {
			setButtonDisabled(false);
			formStateMapping[stateKey].isSet = true;
		}
		console.log(formStateMapping);
		setFromStateMapping(formStateMapping);

		return isError;
	};

	const handleFirstNameChange = () => {
		setFirstNameError("");
		const state = validateField(
			firstNameInput.current.value,
			setFirstNameError,
			"volunteer.register.firstname.error",
			"firstName"
		);
		setFirstNameInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setFirstName(firstNameInput.current.value);

		return state;
	};

	const handleLastNameChange = () => {
		setLastNameError("");
		const state = validateField(
			lastNameInput.current.value,
			setLastNameError,
			"volunteer.register.lastname.error",
			"lastName"
		);
		setLastNameInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setLastName(lastNameInput.current.value);

		return state;
	};

	const handleGenderInputChange = () => {
		setGenderError("");
		const state = validateField(
			genderInput.current.value,
			setGenderError,
			"volunteer.registration.gender.error",
			"gender"
		);
		setGenderInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setGender(genderInput.current.value);

		return state;
	};

	const validateDob = (inputValue, onError, errorMessage, stateKey) => {
		let isError = false;
		const today = moment();
		const age = today.diff(inputValue, "years");

		if (!inputValue.length) {
			onError(formatMessage({ id: errorMessage }));
			isError = true;
		} else if (age < VOLUNTEER_MIN_AGE_IN_YEARS || age >= VOLUNTEER_MAX_AGE_IN_YEARS) {
			onError(
				formatMessage(
					{ id: "volunteer.registration.dob.ageLimitError" },
					{ min: VOLUNTEER_MIN_AGE_IN_YEARS, max: VOLUNTEER_MAX_AGE_IN_YEARS }
				)
			);
			isError = true;
		}

		if (isError) {
			setButtonDisabled(true);
			formStateMapping[stateKey].isSet = false;
		} else {
			setButtonDisabled(false);
			formStateMapping[stateKey].isSet = true;
		}

		return isError;
	};

	const handleDobChange = () => {
		setDobError("");
		const state = validateDob(dobInput.current.value, setDobError, "volunteer.registration.dob.error", "dob");
		setDobInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setDob(parseInt((new Date(dobInput.current.value).getTime() / 1000).toFixed(0)));

		return state;
	};

	const validatePhoneNumber = (inputValue, onError, errorMessage, stateKey) => {
		let isError = false;

		if (!inputValue) {
			onError(formatMessage({ id: errorMessage }));
			isError = true;
		} else if (inputValue.length !== 10) {
			onError(formatMessage({ id: "volunteer.registration.phonenumber.invalid" }));
			isError = true;
		}

		if (isError) {
			setButtonDisabled(true);
			formStateMapping[stateKey].isSet = false;
		} else {
			setButtonDisabled(false);
			formStateMapping[stateKey].isSet = true;
		}

		return isError;
	};

	const handlePhoneNumberChange = () => {
		setPhoneNumberError("");
		const state = validatePhoneNumber(
			phoneNumberInput.current.value,
			setPhoneNumberError,
			"volunteer.registration.phonenumber.error",
			"phoneNumber"
		);
		setPhoneNumberInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setPhoneNumber(phoneNumberInput.current.value);

		if (!state) {
			setSendOtpButtonDisabledState(false);
		} else {
			setSendOtpButtonDisabledState(true);
		}

		return state;
	};

	const startResendOTPTimer = () => {
		let countdown = RESEND_OTP_TIMEOUT_IN_SECONDS;
		resendOTPTimer = setInterval(() => {
			countdown -= 1;
			setResendOTPMessage(formatMessage({ id: "volunteer.registration.otp.resendMessage" }, { time: countdown }));
			if (countdown <= 0) {
				clearInterval(resendOTPTimer);
				setSendOtpButtonDisabledState(false);
				setResendOTPMessage(null);
			}
		}, [1000]);
	};

	const onClickSendOTP = async () => {
		const state = handlePhoneNumberChange();
		if (state) {
			return;
		}

		const sendOTPResponse = await dispatch(sendOTP({ mobileNumber: phoneNumber }));
		if (sendOTPResponse) {
			formStateMapping["isOTPRequested"].isSet = true;
			startResendOTPTimer();
			setSendOtpButtonDisabledState(true);
			dispatch(
				showToast({
					message: "volunteer.registration.phonenumber.OTPsent",
				})
			);
		} else {
			setSendOtpButtonDisabledState(false);
			formStateMapping["isOTPRequested"].isSet = false;
			setPhoneNumberError(formatMessage({ id: "volunteer.registration.phonenumber.APIerror" }));
		}
	};

	const handleOtpChange = () => {
		setOtpError("");
		const state = validateField(otpInput.current.value, setOtpError, "volunteer.registration.otp.error");
		setOtpInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setOtp(otpInput.current.value);

		if (!state) {
			setVerifyOTPButtonDisabledState(false);
		} else {
			setVerifyOTPButtonDisabledState(true);
		}

		return state;
	};

	const onClickVerifyOTP = async () => {
		const state = handleOtpChange();
		if (state) {
			return;
		}

		const verifyOTPResponse = await dispatch(verifyOTP({ mobileNumber: phoneNumber, otp: otp }));
		if (verifyOTPResponse) {
			formStateMapping["isOTPVerified"].isSet = true;
			setVerifyOTPButtonDisabledState(true);
			dispatch(
				showToast({
					message: "volunteer.registration.OTP.verifiedSuccessfully",
				})
			);
		} else {
			setVerifyOTPButtonDisabledState(false);
			formStateMapping["isOTPVerified"].isSet = false;
			setOtpError(formatMessage({ id: "volunteer.registration.OTP.invalid" }));
		}
	};

	const handleCityChange = () => {
		setCityError("");
		const state = validateField(cityInput.current.value, setCityError, "volunteer.registration.city.error", "city");
		setCityInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setCity(cityInput.current.value);

		return state;
	};

	const handleStateChange = () => {
		setStateError("");
		const state = validateField(
			stateInput.current.value,
			setStateError,
			"volunteer.registration.state.error",
			"state"
		);
		setStateInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setState(stateInput.current.value);

		return state;
	};

	const handleAddressChange = () => {
		setAddressError("");
		const state = validateField(
			addressInput.current.value,
			setAddressError,
			"volunteer.registration.address.error",
			"address"
		);
		setAddressInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setAddress(addressInput.current.value);

		return state;
	};

	const handlePincodeChange = () => {
		setPincodeError("");
		const state = validateField(
			pincodeInput.current.value,
			setPincodeError,
			"volunteer.registration.pincode.error",
			"pincode"
		);
		setPincodeInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setPincode(pincodeInput.current.value);

		return state;
	};

	const handleRegionChange = () => {
		setRegion("");
		const state = validateField(
			regionInput.current.value,
			setRegionError,
			"volunteer.registration.region.error",
			"region"
		);
		setRegionInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setRegion(regionInput.current.value);

		return state;
	};

	const handleVolunteerAreaChange = () => {
		setVolunteerAreaError("");
		const state = validateField(
			volunteerAreaInput.current.value,
			setVolunteerAreaError,
			"volunteer.registration.volunteerArea.error",
			"volunteerArea"
		);
		setVolunteerAreaInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setVolunteerArea(volunteerAreaInput.current.value);

		return state;
	};

	const handleStartDateChange = () => {
		setStartDateError("");
	};

	const handleEndDateChange = () => {
		setEndDateError("");
	};

	const openCamera = () => {
		setIsTakingPicture(true);
	};

	const retakePhoto = () => {
		setIsPhotoCaptured(false);
		setIsTakingPicture(true);
	};

	const capturePhoto = () => {
		console.log("==>capturePhoto");
		const imageSrc = webcamRef.current.getScreenshot();
		setWebcamImage(imageSrc);
		setIsPhotoCaptured(true);
		formStateMapping["photo"] = imageSrc ? true : false;
		setFromStateMapping(formStateMapping);
	};

	const handleMedicalConditionInputChange = () => {
		setMedicalConditionError("");
		const state = validateField(
			medicalConditionInput.current.value,
			setMedicalConditionError,
			"volunteer.registration.medicalCondition.error",
			"medicalConditions"
		);
		setMedicalConditionInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setMedicalCondition(medicalConditionInput.current.value);

		return state;
	};

	const handleMedicalConditionChange = (e) => {
		formStateMapping["medicalConditions"].isSet = e.target.checked;
		setHasMedicalCondition(e.target.checked);
	};

	const handleOnAgreeTermsChange = (e) => {
		formStateMapping["termsAndConditions"].isSet = e.target.checked;
		setIsAgreedToTerms(e.target.checked);

		if (!e.target.checked) {
			setIsAgreedToTermsError(formatMessage({ id: "volunteer.registration.isAgreedToTermsError" }));
		} else {
			setIsAgreedToTermsError("");
		}
	};

	const submitForm = async () => {
		let unsetData = {};

		for (let key in formStateMapping) {
			if (!formStateMapping[key].isSet) {
				let item = {};
				item[key] = formStateMapping[key];
				unsetData = {
					...unsetData,
					...item,
				};
			}
		}

		if (Object.keys(unsetData).length) {
			for (let key in unsetData) {
				if (!unsetData[key].isSet && unsetData[key].setErrorFunc) {
					unsetData[key].setErrorFunc(formatMessage({ id: "volunteer.registration.mandatoryFieldError" }));

					if (unsetData[key].setState) {
						unsetData[key].setState(STATE_DANGER);
					}
				}
			}

			return;
		}

		const payload = {
			firstName: firstName,
			lastName: lastName,
			dob: dob,
			mobileNumber: phoneNumber,
			gender,
			city,
			state,
			address,
			pinCode: pincode,
			region: region,
			volunteerArea,
			startDate,
			endDate,
			photo: webcamImage,
			medicalConditions: hasMedicalCondition ? medicalCondition : MEDICAL_CONDITIONS.NONE,
			termsAndConditions: isAgreedToTerms,
		};

		const registerUserResponse = await dispatch(registerVolunteer(payload));
		if (registerUserResponse) {
			setIsRegistrationSuccessful(true);
		} else {
			setIsRegistrationSuccessful(false);
		}
	};

	return (
		<div>
			<Header />

			{!isRegistrationSuccessful ? (
				<>
					{" "}
					<img src={fullLogo} alt="full-logo" className="full-logo" />
					<div className="container-image">
						<img src={formImage} alt="form-image" />
					</div>
					<div className="volunteer-register-form mt-32 flex direction-col align-items-start">
						<div className="text text-header--7 text-bold text-left mb-16">
							{formatMessage({ id: "volunteer.registration.title" })}
						</div>

						<div className="row flex direction-row justify-content-between mt-16">
							<div className="col-lg-4">
								<CustomInput
									id="firstname"
									label="volunteer.register.firstname"
									icon={faUser}
									isMandatory={true}
									placeholder="volunteer.register.firstname.placeholder"
									ref={firstNameInput}
									state={firstNameInputState}
									onChange={handleFirstNameChange}
								/>
								{firstNameError && (
									<div className="text text-body--5 text-left text-danger">{firstNameError}</div>
								)}
							</div>
							<div className="col-lg-4">
								<CustomInput
									id="lastname"
									label="volunteer.register.lastname"
									icon={faUser}
									isMandatory={true}
									placeholder="volunteer.register.lastname.placeholder"
									ref={lastNameInput}
									state={lastNameInputState}
									onChange={handleLastNameChange}
								/>
								{lastNameError && (
									<div className="text text-body--5 text-left text-danger">{lastNameError}</div>
								)}
							</div>
						</div>

						<div className="row flex direction-row justify-content-between mt-16">
							<div className="col-lg-4">
								{genderOptions && (
									<Dropdown
										id="gender"
										label="volunteer.registration.gender"
										icon={faVenusMars}
										isMandatory={true}
										placeholder="volunteer.registration.gender.placeholder"
										ref={genderInput}
										state={genderInputState}
										options={genderOptions}
										onChange={handleGenderInputChange}
									/>
								)}
								{genderError && (
									<div className="text text-body--5 text-left text-danger">{genderError}</div>
								)}
							</div>
							<div className="col-lg-4">
								<CustomInput
									id="dob"
									type="date"
									label="volunteer.registration.dob"
									icon={faCalendar}
									isMandatory={true}
									placeholder="volunteer.registration.dob.placeholder"
									ref={dobInput}
									state={dobInputState}
									onChange={handleDobChange}
								/>
								{dobError && <div className="text text-body--5 text-left text-danger">{dobError}</div>}
							</div>
						</div>

						<div className="row flex direction-row justify-content-between align-items-end mt-16">
							<div className="col-lg-4 flex direction-col align-items-start">
								<div className="flex direction-row align-items-end">
									<CustomInput
										id="phonenumber"
										label="volunteer.registration.phonenumber"
										icon={faPhone}
										isMandatory={true}
										placeholder="volunteer.registration.phonenumber.placeholder"
										ref={phoneNumberInput}
										state={phoneNumberInputState}
										max={10}
										onChange={handlePhoneNumberChange}
									/>
									<Button
										className="button-secondary button-md ml-16"
										label="volunteer.registration.action.sendOTP"
										disabled={sendOtpButtonDisabledState}
										onClick={onClickSendOTP}
									/>
								</div>

								{resendOTPMessage && (
									<div className="text text-body--5 text-left text-disabled">{resendOTPMessage}</div>
								)}
								{phoneNumberError && (
									<div className="text text-body--5 text-left text-danger">{phoneNumberError}</div>
								)}
							</div>
							<div className="col-lg-4 flex direction-col align-items-start">
								<div className="flex direction-row align-items-end">
									<CustomInput
										id="otp"
										type="password"
										label="volunteer.registration.otp"
										icon={faLock}
										isMandatory={true}
										placeholder="volunteer.registration.otp.placeholder"
										ref={otpInput}
										state={otpInputState}
										max={4}
										onChange={handleOtpChange}
									/>
									<Button
										className="button-secondary button-md ml-16"
										label="volunteer.registration.action.verifyOTP"
										disabled={verifyOTPButtonDisabledState}
										onClick={onClickVerifyOTP}
									/>
								</div>

								{otpError && <div className="text text-body--5 text-left text-danger">{otpError}</div>}
							</div>
						</div>

						<div className="row flex direction-row justify-content-between mt-16">
							<div className="col-lg-4">
								<CustomInput
									id="city"
									label="volunteer.registration.city"
									icon={faLocationArrow}
									isMandatory={true}
									placeholder="volunteer.registration.city.placeholder"
									ref={cityInput}
									state={cityInputState}
									onChange={handleCityChange}
								/>
								{cityError && (
									<div className="text text-body--5 text-left text-danger">{cityError}</div>
								)}
							</div>
							<div className="col-lg-4">
								<Dropdown
									id="state"
									label="volunteer.registration.state"
									icon={faLocationArrow}
									isMandatory={true}
									placeholder="volunteer.registration.state.placeholder"
									ref={stateInput}
									state={stateInputState}
									options={STATES}
									onChange={handleStateChange}
								/>
								{stateError && (
									<div className="text text-body--5 text-left text-danger">{stateError}</div>
								)}
							</div>
						</div>

						<div className="row flex direction-row justify-content-between mt-16">
							<div className="col-lg-4">
								<CustomInput
									id="address"
									label="volunteer.registration.address"
									icon={faLocationCrosshairs}
									isMandatory={true}
									placeholder="volunteer.registration.address.placeholder"
									ref={addressInput}
									state={addressInputState}
									max={6}
									onChange={handleAddressChange}
								/>
								{addressError && (
									<div className="text text-body--5 text-left text-danger">{addressError}</div>
								)}
							</div>

							<div className="col-lg-4">
								<CustomInput
									id="pincode"
									label="volunteer.registration.pincode"
									icon={faMapLocation}
									isMandatory={true}
									placeholder="volunteer.registration.pincode.placeholder"
									ref={pincodeInput}
									state={pincodeInputState}
									max={6}
									onChange={handlePincodeChange}
								/>
								{pincodeError && (
									<div className="text text-body--5 text-left text-danger">{pincodeError}</div>
								)}
							</div>
						</div>

						<div className="row flex direction-row justify-content-between mt-16">
							<div className="col-lg-4">
								<Dropdown
									id="region"
									label="volunteer.registration.region"
									icon={faLocationCrosshairs}
									isMandatory={true}
									placeholder="volunteer.registration.region.placeholder"
									ref={regionInput}
									state={regionInputState}
									options={REGION}
									onChange={handleRegionChange}
								/>
								{regionError && (
									<div className="text text-body--5 text-left text-danger">{regionError}</div>
								)}
							</div>

							<div className="col-lg-4">
								<Dropdown
									id="volunteerArea"
									label="volunteer.registration.volunteerArea"
									icon={faLocationCrosshairs}
									isMandatory={true}
									placeholder="volunteer.registration.volunteerArea.placeholder"
									ref={volunteerAreaInput}
									state={volunteerAreaInputState}
									options={VOLUNTEER_AREAS}
									onChange={handleVolunteerAreaChange}
								/>
								{volunteerAreaError && (
									<div className="text text-body--5 text-left text-danger">{volunteerAreaError}</div>
								)}
							</div>
						</div>

						<div className="row flex direction-row justify-content-between mt-16">
							<div className="col-lg-4">
								<CustomInput
									id="startDate"
									type="date"
									label="volunteer.registration.startDate"
									icon={faCalendar}
									isMandatory={true}
									placeholder="volunteer.registration.startDate.placeholder"
									ref={startDateInput}
									state={startDateInputState}
									onChange={handleStartDateChange}
								/>
								{startDateError && (
									<div className="text text-body--5 text-left text-danger">{startDateError}</div>
								)}
							</div>
							<div className="col-lg-4">
								<CustomInput
									id="endDate"
									type="date"
									label="volunteer.registration.endDate"
									icon={faCalendar}
									isMandatory={true}
									placeholder="volunteer.registration.endDate.placeholder"
									ref={endDateInput}
									state={endDateInputState}
									onChange={handleEndDateChange}
								/>
								{endDateError && (
									<div className="text text-body--5 text-left text-danger">{endDateError}</div>
								)}
							</div>
						</div>

						<div className="row flex direction-row justify-content-between mt-16">
							<div>
								{isPhotoCaptured ? (
									<div className="flex direction-row align-items-center">
										<img src={webcamImage} className="webcam-image" alt="webcam-captured-image" />
										<Button
											className="button-secondary button-md ml-16"
											label="public.action.retakePhoto"
											onClick={retakePhoto}
										/>
									</div>
								) : isTakingPicture ? (
									<div className="flex direction-row align-items-center">
										<Webcam ref={webcamRef} audio={false} screenshotFormat="image/jpeg" />
										<Button
											className="button-secondary button-md ml-16"
											label="public.action.capturePhoto"
											onClick={capturePhoto}
										/>
									</div>
								) : (
									<div className="flex direction-col">
										<div className="flex direction-row align-items-center">
											<img src={image} alt="default-avatar" />
											<Button
												className="button-secondary button-md ml-16"
												label="public.action.openCamera"
												onClick={openCamera}
											/>
										</div>

										{photoError && (
											<div className="text text-body--5 text-left text-danger">{photoError}</div>
										)}
									</div>
								)}
							</div>
						</div>

						<div className="row flex direction-col align-items-start mt-16">
							<Checkbox label="public.medical.placeholder" onChange={handleMedicalConditionChange} />
							{hasMedicalCondition ? (
								<>
									<CustomInput
										id="medicalCondition"
										placeholder="public.medicalCondition.placeholder"
										ref={medicalConditionInput}
										state={medicalConditionInputState}
										onChange={handleMedicalConditionInputChange}
									/>
									{medicalConditionError && (
										<div className="text text-body--5 text-left text-danger">
											{medicalConditionError}
										</div>
									)}
								</>
							) : (
								<></>
							)}
						</div>

						<div className="flex direction-col align-items-start mt-16">
							<Checkbox
								label="volunteer.registration.termsAndConditions.placeholder"
								isMandatory={true}
								state={isAgreedToTermsInputState}
								onChange={handleOnAgreeTermsChange}
							/>
							{isAgreedToTermsError && (
								<div className="text text-body--5 text-left text-danger">{isAgreedToTermsError}</div>
							)}
						</div>

						<div className="row  pb-16">
							<div className="col-lg-12 flex direction-col align-items-end">
								<Button
									className="button-primary mt-16"
									label="public.action.submit"
									disabled={buttonDisabled}
									onClick={() => {
										submitForm();
									}}
								/>
							</div>
						</div>
					</div>
				</>
			) : (
				<div className="flex direction-col align-items-center pa-16" style={{ marginTop: 120 }}>
					<img src={registerSuccess} alt="register-success" style={{ width: 200 }} />
					<div className="text text-header--6 mt-16">
						{formatMessage({ id: "volunteer.registration.success" })}
					</div>
					<div className="text text-body--3 mt-16">
						{formatMessage({ id: "volunteer.registration.successDescription" })}
					</div>
				</div>
			)}
		</div>
	);
});
